<template>
  <div class="container">
    <a href="../" title="Accueil">
      <img src="./assets/LOGO_NAEGA_DI.svg" alt="logo naega DI">
    </a>
    <step-progress :progress=progress :theme=themeLight></step-progress>
  </div>
  <upload v-if="progress === 0" @upload-file="processUpload" :form-prop=formData :upload-failed="jobFailed" :error-message="errorCode"></upload>
  <processing v-if="progress === 1" :job-succeeded="jobSucceeded" :position="position"></processing>
  <results v-if="progress === 2" :results=results.result :debit=formData.debit :form-sent=formSent @send-email="sendFormEmail"></results>
</template>

<script>
// import config from '../config'
import StepProgress from '@/components/StepProgress.vue'
import Upload from '@/views/Upload.vue'
import Processing from '@/views/Processing.vue'
import Results from '@/views/Results.vue'

export default {
  components: {
    StepProgress,
    Upload,
    Processing,
    Results
  },
  data () {
    return {
      progress: 0,
      position: 0,
      pollId: null,
      results: null,
      formSent: false,
      jobSucceeded: false,
      jobFailed: false,
      errorCode: null,
      formData: {
        debit: null,
        files: []
      }
    }
  },
  mounted () {
    document.addEventListener('dragstart', this.documentDragHandler, false) // Prevent local objects from being drag/dropped
    document.addEventListener('dragover', this.documentDragHandler, false)
    document.addEventListener('dragenter', this.documentDragHandler, false)
    document.addEventListener('dragleave', this.documentDragHandler, false)

    this.dropZoneInit()
  },
  computed: {
    themeLight () {
      return this.progress === 2
    }
  },
  watch: {
    formData: {
      handler (val) {
        if (val.files.length === 0) {
          this.jobFailed = false
          this.errorCode = ''
          this.dropZoneInit()
        }
      },
      deep: true
    }
  },
  methods: {
    documentDragHandler (e) {
      const dropZone = document.querySelector('#dropZone')
      e.preventDefault()
      switch (e.type) {
        case 'dragenter':
          document.querySelector('.upload .card').classList.remove('shakeX')
          dropZone.classList.add('active')
          break
        case 'dragleave':
          dropZone.classList.remove('active')
          break
      }
    },
    dropZoneDragHandler (e) {
      const dropZone = document.querySelector('#dropZone')
      e.preventDefault()
      e.stopPropagation()
      switch (e.type) {
        case 'dragenter':
          document.removeEventListener('dragleave', this.documentDragHandler)
          break
        case 'dragleave': {
          dropZone.classList.remove('active')
          document.addEventListener('dragleave', this.documentDragHandler)
          break
        }
        case 'drop': {
          dropZone.classList.remove('active')
          document.addEventListener('dragleave', this.documentDragHandler)
          break
        }
      }
    },
    dropZoneInit () {
      const dropZone = document.querySelector('#dropZone')
      dropZone.addEventListener('dragenter', this.dropZoneDragHandler)
      dropZone.addEventListener('dragleave', this.dropZoneDragHandler)
      dropZone.addEventListener('drop', this.dropZoneDragHandler)
    },
    processUpload (form) {
      this.formData = form
      this.progress = 1
      const formData = new FormData()
      formData.append('file', form.files[0])
      formData.append('waterFlow', form.debit)

      const requestOptions = {
        method: 'POST',
        body: formData
      }
      fetch(process.env.VUE_APP_API_LOCATION + 'job/start', requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then(data => this.getJobDone(data.jobId))
        .catch(error => {
          console.error('There has been a problem with your fetch operation:', error)
        })
    },
    getJobDone (jobId) {
      this.pollId = setInterval(() => {
        fetch(process.env.VUE_APP_API_LOCATION + 'job/wait/' + jobId)
          .then(response => response.json())
          .then(result => this.isJobDone(result))
      }, 1000)
    },
    isJobDone (result) {
      if (result?.state === 'waiting') {
        this.position = result?.position
      }
      if (result?.state === 'completed' || result?.state === 'failed') {
        clearInterval(this.pollId)
      }
      if (result?.state === 'completed') {
        this.results = result
        this.jobSucceeded = true
        setTimeout(() => { // for animation purposes
          this.progress = 2
          this.setAppThemeLight()
        }, 2500)
      } else if (result?.state === 'failed') {
        this.progress = 0
        this.formData.debit = null
        this.jobFailed = true
        this.errorCode = 'Votre fichier INP comporte des erreurs à l\'ouverture, veuillez corriger les erreurs puis recharger votre fichier.'
      }
    },
    setAppThemeLight () {
      document.querySelector('body').style.backgroundColor = '#fff'
      document.getElementById('app').classList.add('theme-light')
    },
    sendFormEmail (formData) {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          allowKeepEmail: true,
          email: formData.emailTo,
          answers: {
            mayPayNaega: formData.choice === 'oui',
            whatWouldYouLike: formData.message,
            otherNeeds: formData.message2
          }
        })
      }
      fetch(process.env.VUE_APP_API_LOCATION + 'job/mail/' + this.results.jobId, requestOptions)
        .then(response => response.json())
        .then(data => {
          setTimeout(() => { // for animation purpose
            this.formSent = true
          }, 2000)
        })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Rubik', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-black);
  background-color: var(--primary);
}

#app.theme-light {
  background-color: var(--white);
  height: auto;
}

.container:first-child {
  padding-top: 4rem;
}
</style>
